import type { ComponentProps, ReactNode } from "react";
import { Link, type LinkProps } from "react-router";

type Variant = "primary" | "default" | "ghost";

interface Look {
  variant?: Variant;
  size?: "md" | "sm";
  icon?: boolean;
}

function classes({ variant = "default", size = "md", icon = false }: Look, extra = ""): string {
  return [
    "btn",
    variant === "primary" && "btn-primary",
    variant === "ghost" && "btn-ghost",
    size === "sm" && "btn-sm",
    icon && "btn-icon",
    extra,
  ]
    .filter(Boolean)
    .join(" ");
}

export function Button({
  variant,
  size,
  icon,
  className = "",
  type = "button",
  ...rest
}: ComponentProps<"button"> & Look) {
  return <button type={type} className={classes({ variant, size, icon } as Look, className)} {...rest} />;
}

export function ButtonLink({
  variant,
  size,
  className = "",
  ...rest
}: LinkProps & Look & { children: ReactNode }) {
  return <Link className={classes({ variant, size } as Look, className)} {...rest} />;
}
